import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaymentService } from 'src/app/feature/payment/services/payment.service';
import {
  DiscountBuyDataInterface,
  DiscountType,
  PaymentTokenUrl,
} from 'src/app/shared';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-discount-buy',
  templateUrl: './discount-buy.component.html',
  styleUrls: ['./discount-buy.component.scss'],
})
export class DiscountBuyComponent implements OnInit {
  private paymentTokenObject!: PaymentTokenUrl;
  private subsink = new SubSink();

  // ---------------------Getters and Setters|

  public get discountType(): DiscountType {
    return this.data?.payment?.discountType!;
  }

  public get payment() {
    return this.data?.payment;
  }

  public get paymentRedirectUrl(): string {
    return this.paymentTokenObject?.redirect_url || '';
  }

  // --------------------Constructor|

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DiscountBuyDataInterface,
    private reference: MatDialogRef<DiscountBuyComponent>,
    private paymentService: PaymentService,
    private snackbar: MatSnackBar
  ) {}
  ngOnInit(): void {
    this.construct();
  }

  // --------------------Public methods|

  /**
   * Redirect user to payment url.
   */
  public redirect() {
    window.location.href = this.paymentRedirectUrl;
  }

  // --------------------Private methods|

  /**
   * Send request to api and get
   * redirect url.
   */
  private construct() {
    this.subsink.sink = this.paymentService
      .getPaymentToken(this.payment.id)
      .subscribe(
        (result) => {
          this.paymentTokenObject = result;
        },
        (error) => {
          this.displayMessage('متاسفانه مشکلی در خواندن اطلاعات پیش آمد.');
          this.reference.close();
          console.error(error);
        }
      );
  }

  /**
   * Display any message on material snackbar.
   * @param message Any string message.
   */
  private displayMessage(message: string) {
    this.snackbar.open(message, 'باشه', { duration: 1500 });
  }
}
